import { Filter, Pagination, TextInput } from 'react-admin';
import { List, Datagrid, TextField, BooleanField, DateField } from 'react-admin';
import { PathCategoryEdit } from "./pathCategory.edit.component";

const PathCategoryPagination = (props) => (
    <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const PathCategoryFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" variant={'outlined'} source="q" alwaysOn resettable />
    </Filter>
);

export const PathCategoryList = (props: any) => {
    return (
        <List
            {...props}
            filters={<PathCategoryFilter />}
            bulkActionButtons={false}
            exporter={false}
            actions={null}
            perPage={100}
            pagination={<PathCategoryPagination />}
        >
            <Datagrid rowClick="edit" expand={PathCategoryEdit}>
                <BooleanField source="visible" label="Visible in app?" />
                <BooleanField source="visible_web" label="Visible in web?" />
                <BooleanField source="visible_explore" label="Visible in explore?" />
                <BooleanField source="showGpxDownload" label="GPX download?" />
                <TextField source="name" />
                <TextField source="pageTitle" />
                <DateField source="createdAt" options={{ day: '2-digit', month: 'short', year: 'numeric' }} />
                <DateField source="updatedAt" options={{ day: '2-digit', month: 'short', year: 'numeric' }} />
            </Datagrid>
        </List>
    );
}